
import {formatNumber,getTimeFormat,formatCurrency,dateFormate} from 'utils/utils'
import Office from "assets/images/OfficeGrey.svg";
import Clock from "assets/images/Clock.svg";
import Calendar from "assets/images/Calendar.svg";
import Taxi from "assets/images/Taxi.png";
export const data = [
  {
    date: '12 June 2023',
    description: 'Taxi For One Trip',
    charges: '₹1,74',
    tax: '20%',
    amount: '₹200',
  },
  {
    date: '12 June 2023',
    description: 'Waiting Charge',
    charges: '₹25',
    tax: '20%',
    amount: '₹30',
  },
];



export const filterRideTrackdata = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value:'booked', list: 'Booked', key: 'Status' },
      { value:'accepted', list: 'Accepted', key: 'Status' },
      { value:'dispatched', list: 'Dispatched', key: 'Status' },
      { value:'onGoing', list: 'OnGoing', key: 'Status' },
      { value:'completed', list: 'Completed', key: 'Status' },
      { value:'cancelled', list: 'Cancelled', key: 'Status' },
    ]
  }
];

export const bookingDetailsData = (reservationDetails, details) => {
  const additionalDetails = [];
  const totalTripPrice = Number(reservationDetails?.Payments?.[0]?.tripPrice) +  Number(reservationDetails?.driverAllowance) + Number(reservationDetails?.nightAllowance);
  return [
    ...additionalDetails,
    {
      title: "Passenger Name",
      data: reservationDetails?.Employee?.name,
      isVip: reservationDetails?.isVip && reservationDetails?.isVip,
    },
    {
      title: "City",
      data: reservationDetails?.location,
    },
    {
      title: "Email ID",
      data: reservationDetails?.Employee?.email,
    },
    {
      title: "Phone. No",
      data: `+91 ${reservationDetails?.Employee?.phoneNumber}` || "NA",
    },
    {
      title: reservationDetails?.DriverProfile && "Driver Name",
      data: `${reservationDetails?.DriverProfile?.firstName} ${reservationDetails?.DriverProfile?.lastName}`,
    },
    {
      title: reservationDetails?.DriverProfile && "Driver Phone No.",
      data: reservationDetails?.DriverProfile?.mobile || "NA",
    },
    {
      title: reservationDetails?.DriverProfile && "Vehicle No.",
      data: reservationDetails?.DriverProfile?.Vehicle?.regNumber || "NA",
    },
    {
      title: "Vehicle Category",
      data: reservationDetails?.status.toLowerCase() !== ("booked" || "cancelled")? reservationDetails?.DriverProfile?.Vehicle?.carType : reservationDetails?.MasterCarType?.carType || "NA",
    },
    {
      title: "Duty Type",
      data: reservationDetails?.dutyTypeName,
    },
    {
      title: reservationDetails?.DriverProfile && "Special Instruction",
      data: reservationDetails?.note,
      status: reservationDetails?.status,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Total km",
      data: `${formatNumber(reservationDetails?.actualDistance)}` ,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Drop Time",
       data: getTimeFormat(reservationDetails?.completedAt),
    },
    {
      title: "Rep. Address",
      data: reservationDetails?.sourceAddress,
    },
    {
      title: "Drop Address",
      data: details?.tripAddress || details?.destinationAddress,
    },
    {
      title: !reservationDetails?.DriverProfile && "Special Instruction",
      data: reservationDetails?.note,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Toll & Parking Charges",
      data: `₹ ${formatCurrency(reservationDetails?.tollAndParkingCharges)}`|| 0,
      textType: "textBold",
    },
    {
      title: reservationDetails?.status?.toLowerCase() === "completed" && "Interstate Tax",
      data:`₹ ${formatCurrency(reservationDetails?.interstateTaxCharges)}` || 0,
      textType: "textBold",
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Trip Charges",
      data: `₹ ${formatCurrency(totalTripPrice)}`,
      textType: "textBold",
      inclusive: true,
    },
  ];
};

export const bookingTime = (reservationData) => [
  {
    type: "calendar",
    img: Calendar,
    title: dateFormate(reservationData?.scheduledTime,'ddd DD MMM, YYYY'),
  },
  {
    type: "time",
    img: Clock,
    title:
    getTimeFormat(reservationData?.scheduledTime) ||
      reservationData?.tripEndTime,
  },
  {
    type: "office",
    img: Office,
    title: reservationData?.companyName,
  },
  {
    type: "booked",
    img: Taxi,
    title: reservationData?.status,
  },
];
